// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/Background/background.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/AboutImage/airplane.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact_main_section__aRxju {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  max-width: 100%;
  margin: 0;
  padding: 0;

  .contact_hero_section__2K-g9 {
    margin: 4rem auto;
  }
}

.contact_queries_section__bkYco {
  margin: 4rem auto;

  & img {
    margin-top: 1rem;
    max-width: 100%;
    height: auto;
  }
}

.contact_trade_section__p-vNB {
  max-width: 100%;
  margin: -5px 0 1rem 0;
  padding: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right
      center,
    #ff5c00;
  background-size: contain, cover;
  height: 150px;

  .contact_section__Lzqx3 {
    display: flex;
    align-items: start;
    flex-direction: column;
    margin: 2rem;

    & h6 {
      color: #702800;
      font-family: Inter;
      font-size: 1.1rem;
      font-weight: 700;
    }

    & p {
      text-decoration: underline;
      margin: 0;
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.8rem;
      font-weight: 500;
    }

    & span {
      margin: 0;
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.8rem;
      font-weight: 500;
    }
  }
}

/* --------media-queries---------- */

@media screen and (max-width: 568px) {
  .contact_main_section__aRxju {
    height: auto;

    .contact_hero_section__2K-g9 {
      margin: 2rem auto;
    }
  }

  br {
    display: none;
  }

  .contact_location_section__05p6S {
    margin: 2rem 0;
  }

  .contact_queries_section__bkYco {
    margin: 2rem auto;
  }

  .contact_trade_section__p-vNB {
    height: auto;

    .contact_section__Lzqx3 {
      margin: 0.8rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Contact/contact.module.css"],"names":[],"mappings":"AAAA;EACE,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;;EAEV;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;;EAEjB;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV;;WAES;EACT,+BAA+B;EAC/B,aAAa;;EAEb;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;;IAEZ;MACE,cAAc;MACd,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;MAC1B,SAAS;MACT,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,SAAS;MACT,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;AACF;;AAEA,oCAAoC;;AAEpC;EACE;IACE,YAAY;;IAEZ;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;;IAEZ;MACE,cAAc;IAChB;EACF;AACF","sourcesContent":[".main_section {\n  background-image: url(\"/public/images/Background/background.webp\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: auto;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  .hero_section {\n    margin: 4rem auto;\n  }\n}\n\n.queries_section {\n  margin: 4rem auto;\n\n  & img {\n    margin-top: 1rem;\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n.trade_section {\n  max-width: 100%;\n  margin: -5px 0 1rem 0;\n  padding: 0;\n  background: url(\"/public/images/AboutImage/airplane.png\") no-repeat right\n      center,\n    #ff5c00;\n  background-size: contain, cover;\n  height: 150px;\n\n  .section {\n    display: flex;\n    align-items: start;\n    flex-direction: column;\n    margin: 2rem;\n\n    & h6 {\n      color: #702800;\n      font-family: Inter;\n      font-size: 1.1rem;\n      font-weight: 700;\n    }\n\n    & p {\n      text-decoration: underline;\n      margin: 0;\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-weight: 500;\n    }\n\n    & span {\n      margin: 0;\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-weight: 500;\n    }\n  }\n}\n\n/* --------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  .main_section {\n    height: auto;\n\n    .hero_section {\n      margin: 2rem auto;\n    }\n  }\n\n  br {\n    display: none;\n  }\n\n  .location_section {\n    margin: 2rem 0;\n  }\n\n  .queries_section {\n    margin: 2rem auto;\n  }\n\n  .trade_section {\n    height: auto;\n\n    .section {\n      margin: 0.8rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `contact_main_section__aRxju`,
	"hero_section": `contact_hero_section__2K-g9`,
	"queries_section": `contact_queries_section__bkYco`,
	"trade_section": `contact_trade_section__p-vNB`,
	"section": `contact_section__Lzqx3`,
	"location_section": `contact_location_section__05p6S`
};
export default ___CSS_LOADER_EXPORT___;
